import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  to {
    max-height: auto;
  }
`;

export default styled.div`
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 1rem;
  margin-top: ${({ theme, $marginTop }) => $marginTop || theme.grid.columnGap};
  overflow: hidden;

  ${({ $noAnimation }) => !$noAnimation && css`
    animation: ${fadeIn} .2s;
  `}

  ${({ $info }) => $info && css`
    background-color: #d1ecf1;
    color: #0c5460;
    border: 1px solid #bee5eb;
  `}

  ${({ $success }) => $success && css`
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  `}

  ${({ $danger }) => $danger && css`
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  `}
`;
